import { CSSProperties } from "react";

export const XTechCardSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(66 / 102) * width}
      viewBox="0 0 102 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g filter="url(#filter0_di_507_10)">
        <rect
          x="1"
          y="64.0409"
          width="63.0409"
          height="100"
          rx="2"
          transform="rotate(-90 1 64.0409)"
          fill="url(#paint0_linear_507_10)"
        />
        <rect
          x="1.5"
          y="63.5409"
          width="62.0409"
          height="99"
          rx="1.5"
          transform="rotate(-90 1.5 63.5409)"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <path
        d="M70.6517 35.0623L71.0252 34.9645L71.025 34.5784L71.023 30.5892L71.0229 30.2039L70.6502 30.1059L66.5293 29.0226C66.1349 27.4543 65.4803 25.9845 64.6188 24.6506L66.7193 21.1334L66.9245 20.7898L66.6341 20.5144L63.6622 17.6948L63.3994 17.4455L63.0807 17.6175L59.3511 19.6294C57.9332 18.7991 56.3747 18.1732 54.7122 17.7946L53.5747 13.8943L53.4697 13.5343H53.0947H48.9008H48.526L48.4209 13.8941L47.2815 17.7947C45.6225 18.1732 44.063 18.799 42.6483 19.6292L38.9146 17.6174L38.5956 17.4455L38.333 17.695L35.3631 20.5168L35.073 20.7924L35.2783 21.1358L37.377 24.647C36.5152 25.9846 35.862 27.4546 35.463 29.0224L31.3476 30.106L30.9749 30.2042V30.5896V34.5786V34.9643L31.348 35.0622L35.4629 36.1421C35.8558 37.6878 36.5018 39.1644 37.3767 40.5178L35.2782 44.0349L35.0732 44.3785L35.3634 44.6538L38.3334 47.4714L38.5959 47.7205L38.9145 47.5489L42.6483 45.5387C44.0829 46.3789 45.6481 46.9967 47.2853 47.3696L48.4206 51.2717L48.5255 51.6321L48.901 51.632L53.097 51.6301L53.472 51.6299L53.5769 51.2698L54.7122 47.3697C56.3748 46.9911 57.9331 46.3654 59.3508 45.5367L63.0847 47.551L63.4041 47.7232L63.6669 47.473L66.6306 44.6513L66.9197 44.376L66.7153 44.0331L64.6183 40.5155C65.4781 39.1804 66.1329 37.712 66.529 36.142L70.6517 35.0623ZM40.4273 28.4533L46.6129 22.5767H55.3865L61.5702 28.4532V28.4626H57.7765C56.3437 26.329 53.8373 24.9199 50.9996 24.9199C48.1622 24.9199 45.6558 26.3291 44.2231 28.4626H40.4273V28.4533ZM50.9996 29.5395C52.8075 29.5395 54.2304 30.9277 54.2304 32.5822C54.2304 34.2427 52.8075 35.6288 50.9996 35.6288C49.1926 35.6288 47.7692 34.2427 47.7692 32.5822C47.7692 30.9277 49.1924 29.5395 50.9996 29.5395ZM61.5702 36.743L55.3865 42.6196H46.6129L40.4274 36.743V36.7018H44.2162C44.5343 37.1761 44.9059 37.6157 45.3243 38.0128C46.844 39.4564 48.8618 40.2482 50.9997 40.2482C53.1384 40.2482 55.156 39.4563 56.6758 38.0126C57.0941 37.6156 57.4657 37.1761 57.7837 36.7018H61.5702V36.743Z"
        fill="white"
        stroke="black"
      />
      <defs>
        <filter
          id="filter0_di_507_10"
          x="0"
          y="0"
          width="102"
          height="65.0409"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_507_10"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_507_10"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_507_10"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_507_10"
          />
        </filter>
        <linearGradient
          id="paint0_linear_507_10"
          x1="32.5204"
          y1="64.0409"
          x2="32.5204"
          y2="164.041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D8B2D" />
          <stop offset="0.515625" stopColor="#0C3E0C" />
          <stop offset="1" stopColor="#2D8B2D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
